import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, Input, OnInit } from '@angular/core';
import { ContentService } from 'src/app/shared/services/content/content.service';
import { content } from 'src/assets/content/fallback-content';

import { WindowRefService } from '../../shared/services/window-ref/window-ref.service';

@Component({
  selector: 'survey-side-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './survey-side-button.component.html',
  styleUrl: './survey-side-button.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SurveySideButtonComponent implements OnInit {
  @Input() formId: number;
  sideButtonText: string = content.Data.v4_rcc_root.content.surveySideButtonText;

  constructor(
    private readonly windowRefService: WindowRefService,
    private readonly contentService: ContentService,
  ) {}

  ngOnInit(): void {
    this.contentService.getContent().subscribe((data) => {
      this.sideButtonText =
        data.Data.v4_rcc_root.content.surveySideButtonText ?? this.sideButtonText;
    });
  }

  openSurvey(): void {
    this.windowRefService.getWindow().KAMPYLE_ONSITE_SDK?.showForm(this.formId);
  }
}
